import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import CustomChip from '../../../components/CustomChip.vue';
import CardMaisFiltros from './CardMaisFiltros.vue';
import { ConsultaBoletinsStore } from '../../store/ConsultaBoletinsStore';
import { OPERADORES } from '@/constants/operadores';
import { useRoute } from 'vue-router/composables';
import { GET_BOLETINS } from '@/queries';
import { useLazyQuery } from '@vue/apollo-composable';
import SdsSnackbarQueue from '@ungp/sds-snackbar-queue';
import { useLoader } from '@/composables/useLoader';

interface IOperador {
  operador: string;
  tooltip: string;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardParametrosConsulta',
  setup(__props) {

const store = ConsultaBoletinsStore();

const { filtroBoletins, pagina } = storeToRefs(store);
const { consultaBoletins, limparTodosFiltroBoletins } = store;

const loader = useLoader();

const { query } = useRoute();

const { load, result, variables, error } = useLazyQuery(GET_BOLETINS);

const updateCount = ref(0);

onMounted(async () => {
  const expandirPesquisaAvancada = Boolean(Object.keys(query).length);
  filtroBoletins.value.expandirPesquisaAvancada = expandirPesquisaAvancada;
  const nmTipoBoletim = `${query.nmTipoBoletim}`.replace(/^"(.*)"$/, '$1');
  variables.value = { nmTipoBoletim };

  if (!nmTipoBoletim) return;
  await buscarTipoBoletim();
});

const buscarTipoBoletim = async () => {
  if (!variables.value) return;
  try {
    loader.startLoader();
    await load();

    filtroBoletins.value.boletins = result.value?.tipoBoletins ?? null;
    updateCount.value++;
  } catch {
    SdsSnackbarQueue.error(
      error.value?.message ?? 'Não foi possível pesquisar os boletins'
    );
  } finally {
    loader.dismissLoader();
  }
};

const handleClickTermos = (termo: IOperador) => {
  let dePesquisa = filtroBoletins.value.dePesquisaTermos;

  const { operador } = termo;

  switch (operador) {
    case 'Aspas':
      dePesquisa = dePesquisa ? '"' + dePesquisa + '"' : '""';
      break;
    case 'Interrogacao':
      dePesquisa = dePesquisa ? dePesquisa + '?' : '?';
      break;
    case 'Asterisco':
      dePesquisa = dePesquisa ? dePesquisa + '*' : '*';
      break;
    default:
      dePesquisa = dePesquisa ? `${dePesquisa} ${operador} ` : operador;
  }

  filtroBoletins.value = {
    ...filtroBoletins.value,
    dePesquisaTermos: dePesquisa,
  };
};

const consultar = () => {
  pagina.value = 1;
  consultaBoletins(true);
};

const limpar = () => {
  limparTodosFiltroBoletins();
};

return { __sfc: true,store, filtroBoletins, pagina, consultaBoletins, limparTodosFiltroBoletins, loader, query, load, result, variables, error, updateCount, buscarTipoBoletim, handleClickTermos, consultar, limpar, CustomChip, CardMaisFiltros, OPERADORES }
}

})